<template>
  <div :class="{ 'z-switch-checkbox': true, 'z-switch-checkbox--disabled': disabled }">
    <input
      id="z-switch"
      :checked="value"
      class="z-switch-checkbox__checkbox"
      type="checkbox"
      :disabled="disabled"
    />
    <div
      class="z-switch-checkbox__label"
      :class="{
        'z-switch-checkbox__label--active': loading
      }"
      @click="input"
    >
      <span class="z-switch-checkbox__left-icon">
        <icon type="md-checkmark" />
      </span>
      <span class="z-switch-checkbox__right-icon">
        <icon type="md-close" />
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      input() {
        if (!this.disabled) {
          this.$emit('input', !this.value);
          this.$emit('on-change', !this.value);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .z-switch-checkbox {
    display: flex;

    &--disabled {
      opacity: 0.4;
    }

    &__checkbox {
      height: 0;
      width: 0;
      visibility: hidden;
    }

    &__label {
      cursor: pointer;
      width: 56px;
      height: 26px;
      background: #586e82;
      display: block;
      border-radius: 100px;
      position: relative;
      color: white;

      &:after {
        content: '';
        position: absolute;
        height: 16px;
        width: 16px;
        top: 5px;
        left: 5px;
        background: #fff;
        border-radius: 90px;
        transition: 0.3s;
      }

      &:active:after {
        width: 30px;
      }

      &--active {
        &:before {
          top: 7px;
          left: 7px;
          content: '';
          z-index: 1;
          height: 0;
          width: 0;
          padding: 4px;
          border: 2px solid white;
          border-right-color: $blue-grey;
          border-radius: 100%;
          animation: rotate 1s infinite linear;
          position: absolute;
          transition: 0.3s;
        }
      }
    }

    &__checkbox:disabled + &__label {
      &:hover {
        cursor: not-allowed;
      }

      &:active:after {
        width: 16px;
      }
    }

    &__checkbox:checked + &__label {
      background: $blue;

      &:after {
        left: calc(100% - 5px);
        transform: translateX(-100%);
      }

      &:before {
        left: calc(100% - 19px);
      }
    }

    &__left-icon,
    &__right-icon {
      position: absolute;
      transition: 0.5s;
      visibility: hidden;
      line-height: 24px;
      top: 0;
      vertical-align: middle;
    }

    &__checkbox:checked + &__label &__left-icon {
      visibility: visible;
    }
    &__checkbox:not(:checked) + &__label &__right-icon {
      visibility: visible;
    }
    &__left-icon {
      left: 8px;
    }
    &__right-icon {
      right: 8px;
    }
  }
  @-webkit-keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
</style>
